<template>
  <div style="position:relative">

    <breadcrumbs home="Dashboard" class="grey" :class="darkMode?'darken-3':'lighten-4'">
      <template v-slot:right>

        <v-menu bottom max-width="300" :open-on-click="false" :close-on-click="false" :close-on-content-click="false" content-class="tour-arrow tour-arrow-right purple white--text pt-6 px-4" transition="slide-y-transition" :value="hint">
          <template v-slot:activator="{on:tour}">
            <v-menu offset-y :close-on-content-click="false" nudge-bottom="5">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="mr-3">mdi-tune-variant</v-icon>
              </template>
              <v-card width="350">
                <v-list-item>
                  <v-switch v-model="sortable.options.disabled" label="Enable rearranging" :true-value="false" :false-value="true" hide-details/>
                </v-list-item>
                <v-list-item>
                  <v-switch v-model="enableDelete" label="Remove widgets"/>
                </v-list-item>
                <v-list-item>
                  <v-select label="Add widget" dense outlined :items="eligibleComponents" v-model="widget"
                            hint="Select a widget to add" persistent-hint no-data-text="No more widgets to add"
                            @change="addWidget()"/>
                </v-list-item>
              </v-card>
            </v-menu>
          </template>
          You can customize your dashboard by adding (or removing) widgets and rearranging widgets (by dragging them around).
          <div class="mt-1">
            <v-btn plain class="white--text mt-4 float-right" @click.stop="done()">Got it</v-btn>
          </div>
        </v-menu>
      </template>
    </breadcrumbs>

    <v-card color="grey" :class="darkMode?'darken-3':'lighten-4'" flat height="calc(100vh - 106px)" class="overflow-y">

      <v-container class="pt-7 pb-4" fluid>
        <v-row justify="center" v-if="systemMessage || (company && company.status!=='Active' && company.status!=='Complimentary')">
          <v-card class="mb-6 mx-4 caution" outlined width="100%">
            <v-container fluid>
              <v-row align="center">
                <v-col cols="2" sm="1"><v-icon color="warning" large>mdi-alert</v-icon></v-col>
                <v-col>
                  <div>{{systemMessage}}</div>
                  <template v-if="company.status==='Inactive'">
                    {{company.name}} is inactive
                  </template>
                  <template v-else-if="company.status==='Trial'">
                    {{company.name}} is on a trial that expires {{company.paymentPeriodEnd | formatDate}}.
                    <v-btn plain primary :to="{name:'Settings',params:{initialTab:1}}" v-if="permission('config')">Account settings</v-btn>
                  </template>
                  <template v-else-if="company.status==='Overdue'">
                    Payment is now overdue. Your distillery will become inactive unless payment is made.
                    <v-btn plain primary  :to="{name:'Settings',params:{initialTab:1}}" v-if="permission('config')">Account settings</v-btn>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-row>
        <v-row ref="dashboardComponents" v-resize="onResize" class="pl-2">
          <component v-for="(c,i) in components" :is="c" :key="i"
                     :data="data"  :from="from" :to="to" @delete="deleteComponent(i)"
                     @zoom="zoom($event)" :width="width" :enableDelete="enableDelete"/>
        </v-row>
      </v-container>
    </v-card>

    <v-dialog v-model="zoomView" max-width="500">
      <component :is="zoomComponent" :data="data" :from="from" :to="to" zoomed @close="zoomView=false"/>
    </v-dialog>
  </div>

</template>

<style scoped>
.caution {
  border-color: #fb8c00 !important;
}
</style>

<script>
import sortableJS from 'sortablejs';
import {format,add} from 'date-fns'
import googleCharts from '@/mixins/googleCharts'

export default {
  name: 'Dashboard',
  mixins: [googleCharts],
  data() {
    return {
      hint: false,
      timesShown: 0,
      data: {},
      componentStatus: [{text:'Outstanding',value:'DashboardOutstanding',permission:''},
                        {text:'Sales Status',value:'DashboardSalesStatus',permission:'selling'},
                        {text:'Excise spirits',value:'DashboardExciseSpirits',permission:'inventory'},
                        {text:'Excise warehouose',value:'DashboardExciseWarehouse',permission:'inventory'},
                        {text:'Excise user',value:'DashboardExciseUser',permission:'inventory'},
                        {text:'Excise liability',value:'DashboardExciseLiability',permission:'excise.file'},
                        {text:'Cask summary',value:'DashboardCasks',permission:'inventory'},
                        {text:'Cask aging',value:'DashboardCaskAging',permission:'inventory'},
                        {text:'Distilling rate',value:'DashboardDistillationSummary',permission:'production'},
                        {text:'Distilling history',value:'DashboardDistillationHistory',permission:'production'},
                        {text:'Mashing rate',value:'DashboardMashSummary',permission:'production'},
                        {text:'Mashing history',value:'DashboardMashHistory',permission:'production'},
                        {text:'Bottling rate',value:'DashboardBottlingSummary',permission:'production'},
                        {text:'Bottling history',value:'DashboardBottlingHistory',permission:'production'},
                        {text:'Casking rate',value:'DashboardCaskingSummary',permission:'production'},
                        {text:'Casking history',value:'DashboardCaskingHistory',permission:'production'},
                        {text:'In-bond product shipments',value:'DashboardProductsInBondShipments',permission:'selling'},
                        {text:'Duty-paid product shipments',value:'DashboardProductsDutyPaidShipments',permission:'selling'},
                        {text:'Inventory value',value:'DashboardInventoryValue',permission:'values'},
                        {text:'Shopify orders processed',value:'DashboardShopify',permission:'selling'},
                        {text:'Square shipments',value:'DashboardSquare',permission:'selling'},
                       ],
      componentNames: [],
      defaultComponents: ['DashboardOutstanding',
                          'DashboardExciseSpirits','DashboardExciseLiability',
                          'DashboardInventoryValue',
                          'DashboardSalesStatus',
                          'DashboardCaskAging',
                          'DashboardDistillationSummary',
                          'DashboardMashSummary',
                          'DashboardBottlingSummary'
                          ],
      components: [],
      from: '',
      to: '',
      systemMessage: null,
      zoomView: false,
      zoomComponent: null,
      width: 0,
      sortable: {options:{disabled:true}},
      enableDelete: false,
      widget: null
    }
  },
  computed: {
    eligibleComponents() {
      return this.componentStatus.filter(c => !this.componentNames.some(shown => shown === c.value) && this.permission(c.permission));
    },
    company() {
      return this.$store.getters.company;
    },
    drawer() {
      return this.$store.state.drawer;
    }
  },
  watch: {
    drawer() {
      this.onResize();
    }
  },
  async created() {
    this.$store.dispatch('checkTasks');

    // Only for admin purposes!
    if (this.$route.query.use) {
      const result = await this.$apiCall(`query Dashboard($id:ID!) {
                                            company(id:$id) {
                                              id,name,fiscalYearMonth,
                                              settings {doneSetup,dateFormat,timeFormat,timeZone,multiCurrency,homeCurrency,
                                                        trackLitres,trackKg,trackStrength,useAccounts,
                                                        exciseAccrual,exciseCreateReceipt,excisePaymentToId,excisePaymentMethodId,exicsePaymentAccountRef,excisePaymentItemId,
                                                        lotTrackingForProducts,lotTrackingForDutyPaid},
                                              qboPlan,
                                              addOns,
                                              status,v8,paymentPeriodEnd,excisePeriodEnd,province,
                                              permissions,userSettings,connectedToAccounting,
                                              maxUsers,allowMultipleSites,allowAccounting,allowPO,allowCSVExport,allowWine,allowApprovedFormulation,
                                              allowAudit,allowPlanning,allowRecurringTransactions,
                                              sites {id,name,active,B262,B263,B265,B266,spiritsLicense,userLicense,wineLicense,warehouseLicense,preferred,shippingAddress}
                                            }
                                          }`,
                                          {id:this.$route.query.use});
      if (!result.error) {
        result.data.company.permissions = "config.read config.write production.read production.write inventory.read inventory.write buying.read buying.write po.approve excise.file selling.read selling.write reports values  forecasting.write forecasting.read scheduling.write scheduling.read audit";
        result.data.company.userSettings = '{}';
        result.data.company.allowAudit = true;
        this.$store.state.companies.push(result.data.company);
        this.$store.commit('setCompanyId', this.$route.query.use);
      }
    }

    const dashboardSettings = this.$store.getters.userSettings.dashboard;

    // Only show components that are in user preferences (or all if none in preferences) AND we have permission to show
    const componentNames = dashboardSettings?.componentNames ?? this.defaultComponents;
    this.componentNames = componentNames.filter(name => {
      const component = this.componentStatus.find(c => c.value === name);
      return !!component && this.permission(component.permission);
    });

    await this.loadGoogleCharts();

    let results = await this.$apiCall(`query Dashboard {
                                        systemMessage
                                        company {
                                          status, paymentPeriodEnd
                                        }
                                       }`,{});
    if (!results.error) {
      this.systemMessage = results.data.systemMessage;
      Object.assign(this.company, results.data.company);   // Get updated status/paymentPeriodEnd
    }

    this.refresh();
    this.components = this.componentNames.map(name => {
      if (this.permission(this.componentStatus.find(c => c.value === name)?.permission))
        return () => import('@/views/dashboard/'+name)
    });

    // Show hint on 10th time
    this.timesShown = dashboardSettings?.timesShown ?? 0;
    if (this.timesShown < 10) {
      if (this.timesShown === 9)
        this.hint = true;
      this.timesShown++;
      this.saveSettings();
    }
  },
  mounted() {
    this.onResize();
    const _self = this;
    this.sortable = sortableJS.create(this.$refs.dashboardComponents, {
      disabled: true,
      forceFallback: true,
      onEnd({newIndex, oldIndex}) {
        let selected = _self.components.splice(oldIndex, 1)[0];
        _self.components.splice(newIndex, 0, selected);
        selected = _self.componentNames.splice(oldIndex, 1)[0];
        _self.componentNames.splice(newIndex, 0, selected);
        _self.saveSettings();
      }
    })
  },
  beforeDestroy() {
    this.sortable.destroy();
  },
  methods: {
    onResize() {
      const minWidth = 290 + 16;
      const windowWidth = window.innerWidth - (this.drawer ? 256 : 0) - 8 /* For margins */;
      const number = Math.floor(windowWidth / minWidth);
      this.width = windowWidth / number - 16 - 4;
    },
    refresh() {
      const date = new Date();
      this.to = format(date, 'yyyy-MM-dd');
      this.from = format(add(date,{years:-2}), 'yyyy-MM-dd');
    },
    permission(access) {
      return this.$store.getters.company.permissions.includes(access);
    },
    deleteComponent(index) {
      this.components.splice(index, 1);
      this.componentNames.splice(index, 1);
      this.saveSettings();
    },
    async zoom(name) {
      this.zoomView = true;
      this.zoomComponent = () => import('@/views/dashboard/'+name);
    },
    addWidget() {
      this.componentNames.push(this.widget);
      this.components.push(() => import('@/views/dashboard/'+this.widget));
      this.saveSettings();
      this.$nextTick(() => this.widget = null);
    },
    done() {
      this.hint = false;
    },
    async saveSettings() {
      const settings = this.$store.getters.userSettings;
      const includeOutstanding = settings.dashboard?.includeOutstanding ??
                                {reporting: true, maintenance:true, production:true, inventory:true, sales:true, purchasing:true};
      settings.dashboard = {timesShown:this.timesShown,componentNames:this.componentNames,includeOutstanding};
      this.$store.commit('setUserSettings', settings);
    }
  }
}
</script>